
const initialState = {
    cart: []
}

export function reservations(state = initialState, action) {
    switch (action.type) {
        case 'FETCH_RESERVATION_TIMES':
            return { ...state, reservationTest: 'done' }
        case 'SET_RESRVATION_DATES':
            return { ...state, reservationDates: action.reservationDates }
        case 'SET_SELECTED_RESERVATION_DATE':
            return { ...state, selectedReserveDate: action.selectedReserveDate }
        case 'SET_CART_DATA':
            return { ...state, cart: action.cart }
        case 'SET_RESERVE_LOADING':
            return { ...state, isReserveLoading: action.isReserveLoading, selectedReservation: action.selectedReservation }
        case 'SET_DATES_LOADING':
            return { ...state, isDatesLoading: action.isDatesLoading }
        case 'SHOW_CONFLICT_MSG':
            return { ...state, conflictMsg: action.msg }
        case 'SET_DAY_CONF':
            return { ...state, dayConflictsMsg: action.dayConflictsMsg }
        default:
            return state;
    }
}

